import { COVERGO_SAAS_DEV } from "../consts.js"

export const walaa_dev = {
	"walaa-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "walaa_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
